import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HeaderType, IconType } from '@app/shared/utils';
import { IconName } from '@app/shared/utils/icon/icons';
import { CoreFacade } from '@app/store/core/core.facade';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../utils/icon/icon.component';
import { HyperlinkComponent } from '../hyperlink/hyperlink.component';
import { LoaderComponent } from '../../../core/components/loader/loader.component';
import { RcLoaderSize } from '@rc-df/ds-web-components';

@Component({
  selector: 'app-rc-block',
  templateUrl: './rc-block.component.html',
  styleUrls: ['./rc-block.component.scss'],
  imports: [NgClass, IconComponent, HyperlinkComponent, LoaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RcBlockComponent implements OnChanges {
  /**
   * Properties
   */
  @Input() headerType: HeaderType = HeaderType.Icon;
  @Input() headerIconType: IconType;
  @Input() headerIconName: IconName;

  @Input() index: number;
  @Input() headerTitle: string;
  @Input() isHidden = false;
  @Input() actionButtonIconType: IconType;
  @Input() actionButtonText: string;
  @Input() actionButtonVisible = true;
  @Input() showLoader = false;
  @Input() hyperlink?: { href: string; label: string; icon: IconName };

  @Output() didClickedActionButton: EventEmitter<any> = new EventEmitter();
  HeaderType = HeaderType;

  public rcLoaderSize: RcLoaderSize = 'medium';

  constructor(private coreFacade: CoreFacade) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showLoader) this.coreFacade.toggleLoader(changes.showLoader.currentValue);
  }

  didClickActionButton(event: MouseEvent): void {
    event.preventDefault();

    this.didClickedActionButton.emit();
  }
}
